import { Box } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { InitializationWrapper } from '@planning/components'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { ReleaseHeader } from '../../Components/molecules/ReleaseHeader'
import { NumericReleaseTable } from '../../Components/organisms/NumericReleases/NumericReleaseTable'

export const NumericReleasesPage = observer(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const { numericReleaseItemStore } = usePlanningStore()

  useEffect(() => {
    numericReleaseItemStore.fetchAll()
  }, [numericReleaseItemStore])

  const title = t('numericReleases', 'Numeric releases')

  return (
    <InitializationWrapper isInitializing={!numericReleaseItemStore.hasBeenInitialized}>
      <Box
        sx={{
          minHeight: '100%',
          bgcolor: theme.palette.grey[100],
        }}
      >
        <ReleaseHeader title={title} createPath={`${PATHS.orders.numericReleases.url}/new`} />

        <Box padding={theme.customSpacing.m}>
          <NumericReleaseTable items={numericReleaseItemStore.items} />
        </Box>
      </Box>
    </InitializationWrapper>
  )
})
